const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render',
    complete: 'cart.complete'
  },
  product: {
    updateVariant: 'product.update_variant'
  },
  notice: {
    global: 'notice.global'
  },
  wishlist: {
    global: 'wishlist.global',
    list: 'wishlist.list',
    change: 'wishlist.change'
  }
}

class GlobalEmitter {
  emit(name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })
    document.dispatchEvent(event)
  }

  on(name, callback) {
    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off(name, callback) {
    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export { emitterProps, globalEmitter }
